import { Component, OnInit, forwardRef, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlaceService } from '../../_services/place.service';

@Component({
  selector: 'app-area-autocomplete',
  templateUrl: './area-autocomplete.component.html',
  styleUrls: ['./area-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AreaAutocompleteComponent),
      multi: true
    }
  ]
})
export class AreaAutocompleteComponent implements ControlValueAccessor {
  @Input() placeholder: any = "N'importe quelle Région";
  @Input() value;
  @Input() allowAdd: boolean = false;
  @Output() notFound: EventEmitter<string> = new EventEmitter<string>();
  propagateChange = (_: any) => { };

  private areas: object[];
  private selected: object;
  private showResults: boolean = false;
  private noResults: boolean = false;


  constructor(private service: PlaceService, private elRef: ElementRef) {
  }

  writeValue(value: any): void {
    if (value !== undefined && value !== "" && value !== null) {
      // If an Object is given, just take the ID as value
      if (value instanceof Object) {
        this.value = value.id;
      } else {
        this.value = value;
      }
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeValue(value) {
    this.propagateChange(value);
  }

  search(value) {
    this.service.autocompleteAreas(value || '').subscribe(response => {
      this.areas = response;
      this.noResults = !this.areas.length;
    });
  }

  ngOnInit() {
  }

  selectResult(area) {
    this.elRef.nativeElement.querySelector('#areaSearchInput').value = area.name;
    this.changeValue(area.id);
  }

  onFocus() {
    this.search('');
    this.showResults = true;
  }

  onBlur() {
    setTimeout(function () {
      this.showResults = false;
    }.bind(this), 200);
  }

  triggerAdd(areaName) {
    this.notFound.emit(areaName);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/area-autocomplete/area-autocomplete.component.ts